'use client'

import type { CartItem } from '@/components/Cart'
import { useCart } from '@payloadcms/plugin-ecommerce/client/react'
import { XIcon } from 'lucide-react'
import React from 'react'

import { cn } from '@/utilities/cn'

/** Убрать строку из корзины. Стоит в углу строки, а не поверх фото: так не промахнёшься. */
export function DeleteItemButton({ item }: { item: CartItem }) {
  const { isLoading, removeItem } = useCart()
  const itemId = item.id
  const disabled = !itemId || isLoading

  return (
    <button
      aria-label="Убрать из корзины"
      className={cn(
        'flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-ink/40 transition-colors',
        disabled ? 'cursor-not-allowed opacity-50' : 'hover:cursor-pointer hover:bg-ink hover:text-sun',
      )}
      disabled={disabled}
      onClick={() => {
        if (itemId) removeItem(itemId)
      }}
      type="button"
    >
      <XIcon className="h-4 w-4" />
    </button>
  )
}
